/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Badge_XpInputs */

const id_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ms_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const da_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const de_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const en_us2_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const es_es2_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const es_mx2_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const fil_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const fr_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const it_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const hu_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const nl_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const no_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const pl_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const pt_br2_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const pt_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ro_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const fi_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const sv_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const vi_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const tr_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const cs_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const bg_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ru_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const uk_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ar_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const hi_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const th_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ja_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const zh_cn2_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经验值`)
};

const zh_hant1_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`經驗值`)
};

const ko_home_pulse_badge_xp = /** @type {(inputs: Home_Pulse_Badge_XpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

/**
* | output |
* | --- |
* | "XP" |
*
* @param {Home_Pulse_Badge_XpInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_badge_xp = /** @type {((inputs?: Home_Pulse_Badge_XpInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Badge_XpInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_badge_xp(inputs)
	if (locale === "ms") return ms_home_pulse_badge_xp(inputs)
	if (locale === "da") return da_home_pulse_badge_xp(inputs)
	if (locale === "de") return de_home_pulse_badge_xp(inputs)
	if (locale === "en-US") return en_us2_home_pulse_badge_xp(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_badge_xp(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_badge_xp(inputs)
	if (locale === "fil") return fil_home_pulse_badge_xp(inputs)
	if (locale === "fr") return fr_home_pulse_badge_xp(inputs)
	if (locale === "it") return it_home_pulse_badge_xp(inputs)
	if (locale === "hu") return hu_home_pulse_badge_xp(inputs)
	if (locale === "nl") return nl_home_pulse_badge_xp(inputs)
	if (locale === "no") return no_home_pulse_badge_xp(inputs)
	if (locale === "pl") return pl_home_pulse_badge_xp(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_badge_xp(inputs)
	if (locale === "pt") return pt_home_pulse_badge_xp(inputs)
	if (locale === "ro") return ro_home_pulse_badge_xp(inputs)
	if (locale === "fi") return fi_home_pulse_badge_xp(inputs)
	if (locale === "sv") return sv_home_pulse_badge_xp(inputs)
	if (locale === "vi") return vi_home_pulse_badge_xp(inputs)
	if (locale === "tr") return tr_home_pulse_badge_xp(inputs)
	if (locale === "cs") return cs_home_pulse_badge_xp(inputs)
	if (locale === "bg") return bg_home_pulse_badge_xp(inputs)
	if (locale === "ru") return ru_home_pulse_badge_xp(inputs)
	if (locale === "uk") return uk_home_pulse_badge_xp(inputs)
	if (locale === "ar") return ar_home_pulse_badge_xp(inputs)
	if (locale === "hi") return hi_home_pulse_badge_xp(inputs)
	if (locale === "th") return th_home_pulse_badge_xp(inputs)
	if (locale === "ja") return ja_home_pulse_badge_xp(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_badge_xp(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_badge_xp(inputs)
	return ko_home_pulse_badge_xp(inputs)
});
export { home_pulse_badge_xp as "home.pulse.badge.xp" }